import { ArrayUtils, Encoder, MGPOptional } from '@everyboard/lib';
import { Coord } from '../../jscaip/Coord';
import { GipfCapture } from '../../jscaip/GipfProjectHelper';
import { HexaDirection } from '../../jscaip/HexaDirection';
import { Move } from '../../jscaip/Move';
// A capture at Yinsh is just like a capture at Gipf, with the only difference
// that it needs to be of length 5 rather than 4, and it contains a ring taken
export class YinshCapture extends GipfCapture {
    static encoder = Encoder.tuple([Encoder.list(Coord.encoder), MGPOptional.getEncoder(Coord.encoder)], (capture) => [capture.capturedSpaces, capture.ringTaken], (fields) => new YinshCapture(fields[0], fields[1]));
    static of(start, end, ringTaken = MGPOptional.empty()) {
        const coords = [];
        const dir = HexaDirection.factory.fromMove(start, end).get();
        for (let cur = start; cur.equals(end) === false; cur = cur.getNext(dir)) {
            coords.push(cur);
        }
        coords.push(end);
        return new YinshCapture(coords, ringTaken);
    }
    ringTaken;
    constructor(captured, ringTaken = MGPOptional.empty()) {
        super(captured);
        if (captured.length !== 5) {
            throw new Error('YinshCapture must capture exactly 5 pieces');
        }
        this.ringTaken = ringTaken;
    }
    setRingTaken(ringTaken) {
        return new YinshCapture(this.capturedSpaces, MGPOptional.of(ringTaken));
    }
    equals(other) {
        if (super.equals(other) === false)
            return false;
        if (this.ringTaken.equals(other.ringTaken) === false)
            return false;
        return true;
    }
}
export class YinshMove extends Move {
    initialCaptures;
    start;
    end;
    finalCaptures;
    static encoder = Encoder.tuple([
        Encoder.list(YinshCapture.encoder),
        Coord.encoder,
        MGPOptional.getEncoder(Coord.encoder),
        Encoder.list(YinshCapture.encoder),
    ], (move) => [move.initialCaptures, move.start, move.end, move.finalCaptures], (fields) => new YinshMove(fields[0], fields[1], fields[2], fields[3]));
    constructor(initialCaptures, start, end, finalCaptures) {
        super();
        this.initialCaptures = initialCaptures;
        this.start = start;
        this.end = end;
        this.finalCaptures = finalCaptures;
    }
    isInitialPlacement() {
        return this.end.isAbsent();
    }
    equals(other) {
        if (this === other)
            return true;
        if (this.start.equals(other.start) === false)
            return false;
        if (this.end.equals(other.end) === false)
            return false;
        if (ArrayUtils.equals(this.initialCaptures, other.initialCaptures) === false)
            return false;
        if (ArrayUtils.equals(this.finalCaptures, other.finalCaptures) === false)
            return false;
        return true;
    }
    toString() {
        return 'YinshMove([' +
            this.capturesToString(this.initialCaptures) + '], ' +
            this.start.toString() + ', ' +
            this.end.toString() + ', [' +
            this.capturesToString(this.finalCaptures) + '])';
    }
    capturesToString(captures) {
        return captures
            .map((y) => '[' + y.toString() + ']')
            .join(', ');
    }
}
